import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-image-bold',
  imports: [],
  templateUrl: './icon-image-bold.component.html',
})
export class IconImageBoldComponent {
  @Input() size = '24px'
  @Input() color = 'currentColor'
}
